import { render, staticRenderFns } from "./AnonymousSuccess.vue?vue&type=template&id=5bee432a"
import script from "./AnonymousSuccess.vue?vue&type=script&lang=js"
export * from "./AnonymousSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports